<div class="non-locations-alerts-container">
  <div class="row mb-4"></div>
  <div class="card mt-2">
    <div class="card-header bg-light">
      <div class="row align-items-center">
        <div class="col-md-12">
          <h5 class="mb-0"><strong>Non-Location Alerts</strong></h5>
          <p *ngIf="numRows === 0" class="mb-0">0 alerts</p>
          <p *ngIf="numRows === 1" class="mb-0">1 alert</p>
          <p *ngIf="numRows > 1" class="mb-0">{{ numRows }} alerts</p>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Loading indicator -->
      <!-- <div *ngIf="loading" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading alerts...</p>
      </div> -->

      <!-- Error message -->
      <div *ngIf="error" class="alert alert-danger">
        {{ error }}
      </div>

      <!-- No results message -->
      <div *ngIf="!loading && !error && numRows === 0" class="alert alert-warning">No alerts found.</div>

      <!-- AG Grid -->
      <div class="ag-theme-alpine" style="height: 500px; width: 100%">
        <ag-grid-angular
          class="ag-theme-alpine"
          [getRowId]="getRowId"
          [gridOptions]="gridOptions"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          (gridReady)="onGridReady($event)"
          style="width: 100%; height: 500px"
          (rowClicked)="onRowClicked($event)"
          (modelUpdated)="onModelUpdated()"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>

  <div *ngIf="selectedAlert">
    <div class="card mt-2">
      <div class="card-header bg-light">
        <div class="row align-items-center">
          <div class="col-md-12">
            <h5 class="mb-0" *ngIf="selectedAlert.type === 'status'">
              Info: <strong>{{ selectedAlert!.message_type }}</strong>

              <svg width="24" height="24" fill="none" stroke="currentColor" class="size-6" class="bi bi-information-circle-fill flex-shrink-0 ml-4">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                />
              </svg>
            </h5>
            <h5 class="mb-0" *ngIf="selectedAlert.type !== 'status'">
              Alert: <strong>{{ selectedAlert!.message_type }}</strong>

              <svg
                width="24"
                height="24"
                style="margin-left: 10px"
                [attr.fill]="selectedAlert.type === 'error' ? 'red' : 'orange'"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 mt-2"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 
                          0L.165 13.233c-.457.778.091 1.767.98 
                          1.767h13.713c.889 0 1.438-.99.98-1.767L8.982
                          1.566zM8 5c.535 0 .954.462.9.995l-.35 
                          3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 
                          0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
            </h5>
          </div>
        </div>
      </div>

      <div class="card-body">
        <!-- Alert details -->
        <div class="alert-details">
          <div class="row">
            <div class="col-md-6">
              <p><strong>Timestamp:</strong> {{ selectedAlert!.created_at | date : 'short' }}</p>
              <p><strong>Type:</strong> {{ selectedAlert!.type }}</p>
              <p><strong>Message Type:</strong> {{ selectedAlert!.message_type }}</p>
              <p><strong>Name:</strong> {{ selectedAlert!.name }}</p>
            </div>
            <div class="col-md-6">
              <p><strong>Event Id:</strong> {{ selectedAlert!.event_id }}</p>
              <p><strong>Process Run Date:</strong> {{ selectedAlert!.process_run_date | date : 'short' }}</p>
              <p><strong>Property Id:</strong> {{ selectedAlert!.property_id }}</p>
            </div>
            <div class="col-md-12" style="white-space: pre-wrap">
              <p><strong>Message:</strong></p>
              <p>{{ selectedAlert!.message }}</p>
            </div>
            <div class="col-md-12" style="white-space: pre-wrap">
              <p><strong>Stack:</strong></p>
              <p>{{ selectedAlert!.stack }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
